import type { ReactNode } from "react";

type ChipVariant = "default" | "warning" | "accent" | "mono";

const variantClasses: Record<ChipVariant, string> = {
  default: "border-muted text-foreground/70",
  warning: "border-warning/45 bg-warning/10 text-warning",
  accent: "border-accent/45 bg-accent/10 text-accent",
  mono: "border-muted font-mono font-normal tracking-normal text-foreground/70",
};

export function Chip({
  children,
  variant = "default",
}: {
  children: ReactNode;
  variant?: ChipVariant;
}) {
  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded border px-1.5 py-px align-middle text-2xs font-semibold tracking-wide ${variantClasses[variant]}`}
    >
      {children}
    </span>
  );
}
